window.$ = window.jQuery = require('jquery');
require('./components/validate')

try {
  let bodyId = $('body main').prop('id');
  require('./views/' + bodyId);
  console.log(bodyId + ' script and module loaded');

} catch (error) {
  console.log('This view doesnt have a main script', error);
}

$(function () {
  console.log('app');
  let overlay = $('.overlay');
  let modalBtn = $('.btn-modal');
  let header = $('#header');
  let nav = header.find('nav');
  let hamburger = header.find('.hamburger');

  let btnSubmitForm = $('.btnSubmitForm');

  // let cart = $('#cart');
  // let cartShow = $('#show-cart');
  // let cartClose = $('#cart-close');


  modalBtn.on('click', function(e){
    let el = $(this);
    let target = el.data('target');
    let close = $(target).find('.close-modal');

    $('.modal').fadeOut();

     // Si es el modal de bloqueo, rellenamos los campos
    if (target === "#modal-lock-accessory") {
      let id = el.data('id');
      let pin = el.data('pin');

      $(target).find('input[name="ID"]').val(id);
      $(target).find('input[name="PIN"]').val(pin);
    }

    $(target).fadeIn();

    close.on('click', ()=> {
      $(target).fadeOut();
    })
  });

  hamburger.on('click', function() {
    let el = $(this);

    if (el.hasClass('close')) {
      overlay.fadeOut();
      nav.fadeOut();
      el.removeClass('close');
    } else {
      overlay.fadeIn();
      nav.fadeIn();
      el.addClass('close');
    }
  })

  btnSubmitForm.on('click', function(e) {
    let el = $(this);
    let form = el.closest('form');

    if (form.valid()) {
      setTimeout(() => {
        el.attr('disabled', true);
      }, 1);
      // el.parents('form').submit();
    }

  });


  $("#reclamaciones_edad").on( 'change', function() {
    const checkbox = $(this);

    if(checkbox.is(':checked') ) {
      $('.reclamaciones_edad').addClass('active');
    } else{
      $('.reclamaciones_edad').removeClass('active');
    }
  });

  $('.reclamaciones_btn').on('click', function() {
      $('#reclamaciones_foto').click();
      $('#reclamaciones_foto').on('change', function() {
        const file = $('#reclamaciones_foto')[0].files[0].name;
        $('.reclamaciones_btn').text(file);
      });
  });

  // $('form').submit(function() {
  //   $(this).find("button[type='submit']").prop('disabled',true);
  // });

  // cartShow.on('click', ()=> {
  //   cart.fadeIn();
  // });

  // cartClose.on('click', ()=> {
  //   cart.fadeOut();
  // });

});
